import React, { useState, useEffect } from "react";
import Header from './Header';
import Footer from './Footer';
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import LeftMenu from "./LeftMenu";

const Layout = () => {
  useEffect(() => {
    // Prevent loading scripts multiple times
    if (window.materialDashboardScriptsLoaded) {
      return;
    }

    const scriptUrls = [
      '/assets/js/core/bootstrap.bundle.min.js',
      '/assets/js/plugins/perfect-scrollbar.min.js',
      '/assets/js/plugins/smooth-scrollbar.min.js',
      '/assets/js/material-dashboard.min.js',
    ];
    const scripts = [];

    const loadScripts = async () => {
      for (const src of scriptUrls) {
        // Check if script is already loaded
        if (document.querySelector(`script[src="${src}"]`)) {
          continue;
        }
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = src;
          script.async = false;
          script.onload = resolve;
          script.onerror = reject;
          document.body.appendChild(script);
          scripts.push(script);
        });
      }
      window.materialDashboardScriptsLoaded = true;
    };

    loadScripts().catch((err) => {
      console.error('Failed to load Material Dashboard scripts:', err);
    });

    return () => {
      scripts.forEach((script) => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
    };
  }, []);

  return (
    <>
      <LeftMenu />


      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
        <Header />

        <Outlet />
        <Footer />
      </main>

    </>
  );
};

export default Layout;
